export default "__VITE_PUBLIC_ASSET__3d35abab__"